<template>
    <form class="create__section form" @submit.prevent="registerPost">
        <div class="form__item">
            <h2 class="title title--s title--uppercase">{{ $lang('register.title') }}</h2>
        </div>
        <errors :errors="errors"></errors>
        <div class="form__item form__item--inline">
            <label class="form__inner">
                <span class="form__label">{{ $lang('register.name') }}</span>
                <el-input class="input input--big" :placeholder="$lang('register.name.placeholder')" v-model="formAuth.name" required dusk="name"></el-input>
            </label>
        </div>
        <div class="form__item form__item--inline">
            <label class="form__inner">
                <span class="form__label">{{ $lang('register.email') }}</span>
                <el-input class="input input--big" type="email" :placeholder="$lang('email.input.placeholder')" v-model="formAuth.email" dusk="email"></el-input>
            </label>
        </div>
        <div v-if="locale === 'ru'" class="form__item form__item--inline">
            <label class="form__inner">
                <span class="form__label">{{ $lang('register.phone') }}</span>
                <input-phone class="input input--big" v-model="formAuth.phone"/>
            </label>
        </div>
        <div class="create__price-box" v-if="pageType == pageTypes.full">
            <span class="create__price">{{ price | priceFormat }} {{ prices.currency.symbol }}</span>
            <span class="create__price-type">{{
                    burial || paymentType === paymentTypes.burial ? $lang('register.page.burial') : $lang('register.page.full')
                }}</span>
        </div>
        <div class="form__item">
            <button v-if="pageType == pageTypes.short && !user" class="btn btn--middle btn--main-bg">{{ $lang('register.button1') }}</button>
            <button dusk="registration-checkout" v-if="pageType == pageTypes.full && !user" class="btn btn--middle btn--main-bg">{{ $lang('register.button2') }}</button>
        </div>
        <div class="form__item">
            <el-checkbox v-model="formAuth.checked" required>{{ $lang('register.policy.part1') }} <a class="contacts__link" target="_blank" href="/assets/front/pdf/memorycode_processing_of_personal_data.pdf">{{ $lang('register.policy.part2') }}</a></el-checkbox>
        </div>
        <div class="form__item form__item--inline" id="footer-popup">
            <span class="popup__auth-hint">{{ $lang('register.hint1') }}</span> <button class="btn link" @click.prevent="setType('reset')"><span>{{ $lang('register.button3') }}</span></button>
        </div>
        <div class="form__item form__item--inline">
            <span class="popup__auth-hint">{{ $lang('register.hint2') }}</span> <button class="btn link" @click.prevent="setType('login')"><span>{{ $lang('register.button4') }}</span></button>
        </div>
    </form>
</template>

<script>
    import {mapActions, mapMutations, mapState } from 'vuex';
    import Errors from "../../error/errors";
    import InputPhone from "../../../components/InputPhone";

    export default {
        name: "register",
        components: {Errors, InputPhone},
        props:['price','pageType', 'burial', 'paymentType'],
        data: () => ({
            errors: null,
            paymentTypes: window.laravel.paymentTypes,
            pageTypes: window.laravel.pageTypes,
            locale: window.laravel.locale,
            prices: window.laravel.prices,
        }),
        computed: {
            ...mapState('auth',[
                'formAuth',
                'user',
            ]),
            ...mapState('create',[
                'form',
            ])
        },
        methods: {
            ...mapMutations('create', [
                'setType',
            ]),
            ...mapMutations('auth', [
                'setUser',
                'clearData',
                'generatePassword',
            ]),
            ...mapActions('auth', [
                'register',
            ]),
            registerPost() {
                this.generatePassword();
                this.formAuth.sendPassword = true;
                this.errors = null;

                this.$loading(this.$optionsLoading);

                this.register().then((response) => {
                    this.setUser(response.data.user);

                    this.$dataLayer.push({'event': 'createUser', 'user_id': response.data.user.id});

                    if (response.data.user.hasOwnProperty('show_message')) {
                        this.$appNotify.success(response.data.user.show_message);
                    }

                    this.$emit('create:page');
                }).catch((error) => {
                    let data = error.response.data;

                    if (data.hasOwnProperty('errors')) {
                        this.errors = data.errors;
                    } else if (data.message) {
                        this.$appNotify.error(data.message);
                    }
                }).finally(() => {
                    this.$loading({}).close();
                });
            }
        },
        beforeDestroy() {
            this.$nextTick(() => {
                this.clearData();
            });
        },
    }
</script>

<style scoped>

</style>
